import { Textarea, type TextareaProps } from "@mantine/core";
import classNames from "classnames";
import type { CommonFormFieldItemProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { FormFieldRightSection } from "../FormFieldRightSection";

interface FormFieldTextareaProps
  extends CommonFormFieldItemProps, TextareaProps {
  type: "textarea";
}

function FormFieldTextarea({
  helpText,
  highlight,
  isBetaFeature,
  type,
  warned,
  ...fieldSpecificProps
}: FormFieldTextareaProps) {
  return (
    <Textarea
      {...fieldSpecificProps}
      aria-label={
        typeof fieldSpecificProps.label === "string"
          ? fieldSpecificProps.label
          : undefined
      }
      className={classNames("FormFieldTextarea", fieldSpecificProps.className)}
      defaultValue={undefined}
      label={
        fieldSpecificProps.label && (
          <FormFieldLabel
            helpText={helpText}
            highlight={highlight}
            isBetaFeature={isBetaFeature}
            label={fieldSpecificProps.label}
            required={fieldSpecificProps.required}
          />
        )
      }
      labelProps={{ w: "100%", ...fieldSpecificProps.labelProps }}
      rightSection={
        <FormFieldRightSection
          rightSection={fieldSpecificProps.rightSection}
          warned={warned}
        />
      }
      value={fieldSpecificProps.value || fieldSpecificProps.defaultValue || ""}
    />
  );
}

export { FormFieldTextarea, FormFieldTextareaProps };
